export enum PersistedUserNavigationSearchParams {
  CIDADE = 'cidade',
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_TERM = 'utm_term',
  UTM_CONTENT = 'utm_content',
  FB_CLID = 'fbclid',
}
